export default {
  'setFormFieldValue.title': 'Set Form Field Value Action',

  'setFormFieldValue.form.responseHttpStatusCode': 'Http Response Code',
  'setFormFieldValue.form.sourceParameterPosition': 'Response Parameter Position',
  'setFormFieldValue.form.valueDestination': 'Value Destination',
  'setFormFieldValue.form.sourceForm': 'Source Form',
  'setFormFieldValue.form.sourceField': 'Source Field',
  'setFormFieldValue.form.formFieldValueSource': 'Field Value Source',

  'setFormFieldValue.form.valueSource': 'Value Source',
  'setFormFieldValue.form.sourceVariable': 'Source Variable',
  'setFormFieldValue.form.form': 'Form',
  'setFormFieldValue.form.field': 'Field',

  'setFormFieldValue.form.select.FormField': 'Form / Field',
  'setFormFieldValue.form.select.Variable': 'Variable',
  'setFormFieldValue.form.select.Formula': 'Formula',
  'setFormFieldValue.form.select.FixedValue': 'Fixed Value',
  'setFormFieldValue.form.select.InternalField': 'Internal Field',
  'setFormFieldValue.form.select.IterationStepData': 'Iteration / Data',
  'setFormFieldValue.form.select.GeneratedDocument': 'Generated Document',
};
